<template>
  <div>
    <span class="icon-loading" v-show="isShowLoadingIcon" :style="loadingStyle">
      <div class="circle1"></div>
      <div class="circle2"></div>
    </span>
  </div>
</template>

<script>
export default {
    data(){
        return{
        }
    },
    props: ['isShowLoadingIcon','loadingStyle']
};
</script>

<style lang="less">
.icon-loading {
  z-index: 99999;
  width: 66px;
  height: 22px;
  line-height: 22px;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 11px;
  position: absolute;
  text-align: right;
  padding-right: 12px;
  top: 5px;
  right: 0;
  cursor: not-allowed;
  .circle1 {
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background-color: #415af6;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -7.5px;
    margin-top: -7.5px;
    opacity: 0.4;
    animation: bounce 2s infinite ease-in-out;
  }
  .circle2 {
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background-color: #415af6;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -7.5px;
    margin-top: -7.5px;
    opacity: 0.6;
    animation: bounce 2s infinite ease-in-out;
    animation-delay: -1s;
  }
  @keyframes bounce {
    0%,
    100% {
      transform: scale(0);
    }
    50% {
      transform: scale(1);
    }
  }
}
</style>
